/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

import { gsap } from 'gsap';
import { Object3D } from 'three';
import { Text } from 'troika-three-text';

import type CardGL from '../../CardFGUp';

import PerformanceProfile from '../../../../utils/PerformanceProfile';

const GLOBAL_CONFIG = {
    letterSpacing: -0.048,
    fontSize: 0.185,
    margin: 0.0,
    color: '#ffe3e3',
};

let GUI;

const addGUI = async () => {
    await PerformanceProfile.devModeReady();

    GUI = PerformanceProfile.GUI.floorGameDown.addFolder({
        title: 'TextSequence',
        expanded: false,
    });

    GUI.addButton({ title: 'Export Config' }).on('click', () => {
        // TODO: What is `CONFIG`?
        PerformanceProfile.exportConfig('TextSequence', { ...GLOBAL_CONFIG, ...CONFIG });
    });

    GUI.addInput(GLOBAL_CONFIG, 'letterSpacing', { min: -0.1, max: 0, step: 0.001 });
    GUI.addInput(GLOBAL_CONFIG, 'fontSize', { min: 0.1, max: 1, step: 0.001 });
    GUI.addInput(GLOBAL_CONFIG, 'margin', { min: 0, max: 0.3, step: 0.001 });
    GUI.addInput(GLOBAL_CONFIG, 'color');
};

if (PerformanceProfile.devMode) addGUI();

export default class TextSequence extends Object3D {
    content: string[];
    time = 0.0;
    visible = false;

    text: Text;
    texts: Text[];

    // TODO: These need to be explicitly set within the constructor.
    // Otherwise, it needs to accept `undefined`.
    textSize: number;
    textMargin: number;

    // TODO: None of these properties are used in this class.
    card: CardGL;
    textColor: string;

    constructor() {
        super();
        // TODO: These should come from `i18n`.
        this.content = ['Someone', 'undercut', 'the', 'floor'];
        this.texts = [];
        this.initText();
    }

    initText() {
        this.textSize = GLOBAL_CONFIG.fontSize;
        this.textMargin = GLOBAL_CONFIG.fontSize + GLOBAL_CONFIG.fontSize * GLOBAL_CONFIG.margin;

        for (let i = 0; i < this.content.length; i++) {
            const text = new Text();
            this.add(text);

            text.font = '/assets/fonts/tusker-grotesk-4500-medium-webgl.woff';
            text.text = this.content[i].toUpperCase();
            text.fontSize = this.textSize;
            text.textAlign = 'center';
            text.anchorX = 'left';
            text.anchorY = 'middle';
            text.letterSpacing = GLOBAL_CONFIG.letterSpacing;

            text.color = GLOBAL_CONFIG.color;
            text.position.y = this.textMargin * -i;
            text.__saveY = text.position.y;

            text.sync();
            this.texts.push(text);
        }

        if (PerformanceProfile.devMode) {
            GUI.on('change', this.updateTextConfig.bind(this));
        }
    }

    updateTextConfig() {
        this.textSize = GLOBAL_CONFIG.fontSize;
        this.textMargin = GLOBAL_CONFIG.fontSize + GLOBAL_CONFIG.fontSize * GLOBAL_CONFIG.margin;

        this.texts.forEach((text, i) => {
            text.fontSize = this.textSize;
            text.letterSpacing = GLOBAL_CONFIG.letterSpacing;
            text.color = GLOBAL_CONFIG.color;
            text.position.y = this.textMargin * -i;
            text.__saveY = text.position.y;
            text.sync();
        });

        this.visible = true;
        this.position.z = 3.0;
    }

    animateIn(delay: number) {
        this.visible = true;
        this.position.z = 3.0;

        this.texts.forEach((text, index) => {
            gsap.fromTo(
                text.material,
                {
                    opacity: 0,
                },
                {
                    opacity: 1,
                    ease: 'power2.out',
                    duration: 1.2,
                    delay: delay + index * 0.025,
                },
            );
            gsap.fromTo(
                text.position,
                {
                    y: text.__saveY + 0.12 + 0.05 * index,
                },
                {
                    y: text.__saveY,
                    ease: 'power3.out',
                    duration: 1.0,
                    delay: delay + index * 0.025,
                },
            );
        });
    }

    animateOut(delay: number) {
        gsap.fromTo(
            this.position,
            {
                y: 0.32,
            },
            {
                y: 1.3,
                ease: 'power1.inOut',
                duration: 1.2,
                delay: delay,
                onComplete: () => {
                    this.visible = false;
                },
            },
        );
    }

    setPosition() {
        /*
        if (width * 0.5 < 1100) {
            this.position.x = 0;
        } else {
            this.position.x = -0.2;
        }
        */
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    update(elapsed: number) {
        /*
        this.texts[0].position.x = Math.cos(Date.now() * 0.001) * 0.5;
        this.time = elapsed;
        this.position.y = this.time % ((this.textSize + this.textMargin) * 3.0);
        */
    }

    delete() {
        this.texts.forEach((text) => {
            this.remove(text);
            text.dispose();
        });
    }
}
